const getConfig = (isNew2, isLocal, isMirror, backendApi) => {
  const mainApiUrl = isMirror ? 'mirror-api.papajohns.pl' : 'staging-api.papajohns.pl';
  const ssrApiUrl = isLocal ? mainApiUrl : backendApi;

  return {
    credentials: isNew2 ? 'include' : 'same-origin',
    // Api Urlgit
    apiUrl: `https://${mainApiUrl}/`,
    ssrUrl: `http://${ssrApiUrl}/`,
    // WebSocket url
    wssUrl: `wss://${mainApiUrl}/`,
    // Юрлицо Рус/Англ
    legal: 'pl',
    // GTM id
    GTM: 'GTM-M82SDQHZ',
    // Default Lang
    lang: 'pl',
    langList: ['pl', 'en'],
    // Телефон
    phone: {
      format: '+.. ...-...-...',
      digitsCount: 12,
      firstNumbers: '+48',
    },
    reCaptchaSiteKey: isNew2
      ? '6LcVmnIaAAAAALWDBJver3YCO3AZsqrt4lXxzXJL'
      : '6LeVmnIaAAAAACCABy9eX7r586I5Zyt4nHN_VAdl',
    merchantID: '',
  };
};

module.exports = getConfig;
